import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSparkle"><Path fillRule="evenodd" clipRule="evenodd" d="M22 12C15.0556 12 12 15.0556 12 22C12 15.0556 8.94444 12 2 12C8.94444 12 12 8.94444 12 2C12 8.94444 15.0556 12 22 12Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconSparkle;
